module.exports = __webpack_public_path__ + "media/Mother-Earth-Song-A.ecaf44b1.mp3";